var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 67,
    viewBox: "0 0 75 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "reacta"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "reactc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "reactb",
    d: "M0 .014h74.987v66.952H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "reacta"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "reactc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "reacta"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "reactc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E67DF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBAA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "reactb",
    d: "M0 .014h74.987v66.952H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 26.36c-3.655 0-6.618 2.951-6.618 6.59 0 3.64 2.963 6.591 6.618 6.591 3.655 0 6.618-2.95 6.618-6.59 0-3.64-2.963-6.59-6.618-6.59",
    fill: "url(\"#reacta\")"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "reactd",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reactb",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.877 37.913c-2.178 1.8-5.32 3.413-9.086 4.665-.41.136-.83.268-1.26.396a68.491 68.491 0 00-2.078-5.668 87.272 87.272 0 00-1.717-3.862 85.472 85.472 0 001.55-3.56 69.931 69.931 0 002.1-5.839c.766.222 1.508.457 2.226.705 3.518 1.216 6.446 2.753 8.466 4.445 1.745 1.461 2.706 2.963 2.706 4.229 0 1.346-1.032 2.94-2.907 4.49zM56.712 48.705c.742 3.762.866 7.197.36 9.934-.433 2.345-1.305 4.004-2.455 4.672-1.094.635-2.843.58-4.926-.155-2.43-.858-5.176-2.574-7.942-4.964a46.277 46.277 0 01-1.883-1.722 68.508 68.508 0 003.805-4.585 87.083 87.083 0 002.483-3.43c1.306-.117 2.59-.26 3.846-.43a68.888 68.888 0 006.306-1.142c.153.621.289 1.229.406 1.822zM25.566 63.08c-2.241.795-4.109.865-5.26.2-1.094-.634-1.92-2.183-2.325-4.362-.473-2.54-.363-5.785.317-9.385.154-.815.337-1.65.547-2.504a68.03 68.03 0 005.864 1.02c1.373.18 2.788.33 4.24.448a85.226 85.226 0 002.78 3.71 72.807 72.807 0 003.661 4.277c-.48.465-.957.906-1.43 1.322-2.876 2.523-5.778 4.347-8.394 5.274zM14.748 42.56c-3.615-1.24-6.639-2.852-8.746-4.663-1.805-1.55-2.799-3.14-2.799-4.473 0-1.268.925-2.76 2.602-4.2 1.957-1.68 4.813-3.206 8.26-4.411.825-.289 1.686-.56 2.58-.816.941 3.07 2.173 6.272 3.654 9.504a85.254 85.254 0 00-1.839 4.325 72.909 72.909 0 00-1.862 5.317 39.383 39.383 0 01-1.85-.583zm3.628-24.77c-.714-3.665-.856-6.978-.41-9.58.387-2.248 1.2-3.835 2.292-4.469 1.16-.674 3.053-.577 5.327.275 2.643.99 5.608 2.912 8.576 5.556.373.333.749.68 1.125 1.042-2.183 2.353-4.336 5.027-6.388 7.933a84.702 84.702 0 00-4.652.562c-1.868.279-3.656.613-5.356.999a47.558 47.558 0 01-.514-2.317zm32.345 8.018a102.338 102.338 0 00-2.28-3.767c2.387.303 4.68.705 6.839 1.2a69.025 69.025 0 01-2.4 6.483c-.68-1.295-1.4-2.602-2.159-3.916zm-13.19-12.897a68.824 68.824 0 014.412 5.347 93.896 93.896 0 00-8.863-.002 70.595 70.595 0 014.45-5.345zm-13.275 12.92a95.568 95.568 0 00-2.119 3.89 70.94 70.94 0 01-2.383-6.513 69.775 69.775 0 014.964-.919c.608-.09 1.22-.175 1.837-.252a94.583 94.583 0 00-2.3 3.793zM22.14 37.28a95.515 95.515 0 004.479 7.76 79.48 79.48 0 01-1.495-.182 65.232 65.232 0 01-5.416-.933 70.032 70.032 0 011.732-4.921c.225-.574.459-1.149.7-1.724zm15.48 16.888a69.921 69.921 0 01-3.386-3.965c-.38-.48-.756-.966-1.13-1.46 1.436.058 2.9.086 4.39.086 1.53 0 3.041-.033 4.53-.1-.299.407-.598.808-.898 1.2a65.711 65.711 0 01-3.507 4.24zm10.338-14.616a105.306 105.306 0 01-3.592 5.82c-2.227.16-4.528.242-6.872.242-2.335 0-4.605-.072-6.792-.215a91.044 91.044 0 01-3.662-5.833 90.842 90.842 0 01-3.202-6.066 91.067 91.067 0 013.192-6.064 90.61 90.61 0 013.635-5.813 90.36 90.36 0 016.829-.256c2.317 0 4.607.088 6.84.258a96.722 96.722 0 013.614 5.793 105.558 105.558 0 013.234 6.038 96.68 96.68 0 01-3.224 6.096zm5.537-1.01c.754 1.817 1.4 3.569 1.932 5.243a68.007 68.007 0 01-6.991 1.196c.776-1.235 1.543-2.51 2.297-3.822.764-1.33 1.49-2.662 2.177-3.99.201.46.396.918.585 1.372zm-3.93-34.656c1.19-.438 2.267-.659 3.177-.659.723 0 1.341.14 1.825.42 1.162.672 2.022 2.366 2.423 4.77.465 2.792.287 6.33-.514 10.232-.1.489-.212.987-.335 1.492-3.118-.722-6.497-1.257-10.027-1.59a85.421 85.421 0 00-2.352-3.203 69.658 69.658 0 00-3.986-4.737 47.261 47.261 0 011.724-1.585c2.806-2.451 5.596-4.228 8.066-5.14zm21.565 22.84c-2.317-1.94-5.594-3.675-9.476-5.017a50.036 50.036 0 00-2.411-.763c.136-.558.26-1.107.37-1.648.88-4.286 1.066-8.232.536-11.412-.57-3.418-1.946-5.847-3.982-7.025-1.958-1.133-4.622-1.13-7.706.007-2.833 1.045-5.967 3.028-9.064 5.733a50.276 50.276 0 00-1.867 1.717c-.415-.399-.83-.783-1.243-1.151-3.26-2.905-6.574-5.037-9.583-6.164C23.471-.207 20.686-.223 18.653.96c-1.956 1.135-3.285 3.454-3.843 6.705-.512 2.984-.366 6.7.422 10.744.159.815.344 1.647.554 2.492-.96.274-1.887.566-2.776.877-3.819 1.335-7.03 3.066-9.287 5.003C1.287 28.871 0 31.17 0 33.424c0 2.32 1.355 4.712 3.919 6.916 2.412 2.073 5.798 3.893 9.793 5.263.652.223 1.328.436 2.028.637a49.698 49.698 0 00-.59 2.693c-.753 3.988-.863 7.645-.318 10.575.588 3.162 1.928 5.429 3.874 6.556 1.016.587 2.22.881 3.577.881 1.319 0 2.78-.278 4.35-.834 2.994-1.061 6.257-3.096 9.435-5.885.52-.457 1.042-.94 1.567-1.449a49.516 49.516 0 002.024 1.853c3.066 2.647 6.168 4.57 8.969 5.559 1.468.518 2.841.777 4.09.777 1.322 0 2.503-.291 3.503-.872 2.002-1.163 3.385-3.537 4-6.868.58-3.134.453-6.988-.367-11.145-.13-.656-.28-1.328-.45-2.013.475-.141.94-.287 1.394-.438 4.138-1.375 7.635-3.185 10.115-5.234 2.665-2.203 4.074-4.614 4.074-6.972 0-2.269-1.333-4.585-3.856-6.698z",
    fill: "url(\"#reactc\")",
    mask: "url(#reactd)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/reactjs.95dd633bcbe8fdd9d6e8d05f89d496e0.svg";
export { ForwardRef as ReactComponent };